import axios from 'axios'

const url = process.env.REACT_APP_API_URL_SIGNATURE

const authConfig = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
})

class SignatureService {
    getStatus(documentId) {
        return axios.get(`${url}/documents/${documentId}/signature-status`, authConfig())
    }

    sign(documentId, payload) {
        const config = authConfig()
        config.headers['Content-Type'] = 'application/json'
        return axios.post(`${url}/documents/${documentId}/sign`, payload, config)
    }

    // Endpoint publik (tanpa login): hasil verifikasi kode TTE.
    verify(verificationCode) {
        return axios.get(`${url}/verify/${encodeURIComponent(verificationCode)}`)
    }

    // URL publik PDF bertanda tangan untuk kode verifikasi.
    verifiedDocumentUrl(verificationCode) {
        return `${url}/verify/${encodeURIComponent(verificationCode)}/document`
    }

    downloadSigned(documentId) {
        return axios.get(`${url}/documents/${documentId}/download-signed`, {
            ...authConfig(), responseType: 'blob'
        })
    }
}

export default new SignatureService()
